import styled from "styled-components";

export const Content = styled.div`
    .results {
        width: 100%;
        height: 30vh;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .results h1 {
        font-size: 250%;
        color: #000;
        font-weight: 500;
    }
`;
